import { combineReducers } from 'redux';
import reducer from "./Emergency";

export default combineReducers({
  reducer
});
